<template>
  <div>
    <crud-tag
      :embedprops="{
        params: {
          module: $store.state.route.params.p1,
          action: $store.state.route.params.p2 || 'list',
          id: $store.state.route.params.p3 || null
        },
        props: {
          filtro: true,
          gc: true,
          rodape: true,
          paginacao: false,
          titulo: false,
          select: false,
          exportserver: false,
          acoes: true
        }
      }"
    />
  </div>
</template>

<script>
/* eslint-disable */

try {
  var Features = require("@/classes/metadmin/features").default;
} catch (err) {
  var Features = require("@/framework/classes/metadmin/features").default;
}
global.features = new Features();

try {
  var _base = require("@/page/_base.vue").default;
} catch (err) {
  var _base = require("@/framework/page/_base.vue").default;
}

export default {
  extends: _base,
  data() {
    return {};
  },
  methods: {
    onInit() {
      this.params = false;
    }
  },

  async beforeMount() {
    console.log(this.$router);
    if (this.$store.state.user) {
      this.profile = await global.features.loadProfile(this.$store);
    }
  }
};
</script>

<style scoped>
h1 {
  color: red;
}
</style>
